import { TokenInterface } from "../api/interface/tokenInterface.ts";
import { jwtDecode } from "jwt-decode";
import { SessionAlert } from "../components/alert/userAlert.js";

const tokenData = async (): Promise<TokenInterface | null> => {
    const token = localStorage.getItem("token");
    
    if (!token) return null;

    try {
        const decodedToken: TokenInterface = jwtDecode(token);
        const currentTime = Date.now() / 1000;

        if (decodedToken.exp < currentTime) {
            console.warn("Token expirado");
            localStorage.removeItem("token");
            SessionAlert("Inicia sesión de nuevo", "#00476e");
            setTimeout(() => {
                window.location.reload();
            } , 1500);
            return null;
        }

        return decodedToken;
    } catch (error) {
        console.error("Error decoding token:", error);
        return null;
    }
};

export default tokenData;
